import { useCallback, useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { dispatcher } from 'dispatcher';
import uuid from 'uuid-random';

import { USER_PHASES } from '@interlayer/js/app/hooks/auth/constants';
import { VALIDATION_EVENTS } from '@interlayer/js/app/hooks/useValidationRules/constants';
import { useValidationRules } from '@interlayer/js/app/hooks/useValidationRules/useValidationRules';
import {
    setAdditionalUpgradeData,
    setAttemptId,
    setIsUpgrade,
    setRegistrationNameStep,
    setUpgradeData } from '@interlayer/js/app/store/reducers/Registration/actions';
import { STEP_NAMES } from '@interlayer/js/app/store/reducers/Registration/constants';

import { FIELDS_JOIN_NOW_UPGRADE } from '../components/JoinNowUpgrade/constnts';

import { useCheckMembership } from './useCheckMembership';

export const useSubmitJoinNow = ({ handlerSubmitProp, handlerFoundUser }: {
    handlerSubmitProp?: () => Promise<void>;
    handlerFoundUser?: () => void;
}) => {
    const dispatch = useDispatch();
    const checkMembership = useCheckMembership({ handlerFoundUser });
    const validationConfig = useValidationRules(FIELDS_JOIN_NOW_UPGRADE);

    const handlerSubmit = useCallback(async ({ membershipNumber }: { membershipNumber: string }) => {
        const phase = await checkMembership(membershipNumber);

        if (!phase) {
            dispatcher.dispatch(VALIDATION_EVENTS.SET_MEMBERSHIP_ERROR, membershipNumber);

            return;
        }

        if (handlerSubmitProp) {
            await handlerSubmitProp();
        }

        dispatch(setAttemptId(uuid()));

        dispatch(setIsUpgrade(true));
        dispatch(setAdditionalUpgradeData({ phase }));
        dispatch(setUpgradeData({ stepName: STEP_NAMES.MEMBERSHIP_STEP, data: { membershipNumber } }));
        dispatch(setRegistrationNameStep(phase === USER_PHASES.preRegistered ? STEP_NAMES.NO_PIN_STEP : STEP_NAMES.PIN_STEP));
    }, [checkMembership, dispatch, handlerSubmitProp]);

    return useMemo(() => ({
        validationConfig,
        handlerSubmit
    }), [handlerSubmit, validationConfig]);
};

